import React from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { usePermissions, permissionsShape } from 'modules/taboola-common-frontend-modules/authentication';
import { ExternalLink } from '../ExternalLink';
import { InternalLink } from '../InternalLink';
import styles from './adminDropdown.module.scss';

export const OptionWrapper = ({ permissions, operator, href, children, newTab }) => {
    const isPermitted = usePermissions(permissions, operator);

    if (!isPermitted) {
        return null;
    }

    if (newTab) {
        return (
            <ExternalLink href={href} className={styles['link']}>
                {children}
            </ExternalLink>
        );
    }
    return (
        <InternalLink className={styles['link']} path={href}>
            {children}
        </InternalLink>
    );
};

OptionWrapper.propTypes = {
    href: PropTypes.string,
    children: PropTypes.node,
    history: PropTypes.object,
    operator: PropTypes.string,
    permissions: permissionsShape,
    componentProps: PropTypes.object,
};

export default withRouter(OptionWrapper);
